import React, { useState } from "react";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";
import * as actionTypes from "../../store/actions";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const SidebarLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 8px 18px 18px;
  height: 48px;
  text-decoration: none;
  margin-bottom: 5px;
  color: ${({ sidebarActive }) => sidebarActive ? "#FFFFFF" : "#000000"};
  background: ${({ sidebarActive }) => sidebarActive ? "#5088FB" : ""};
  border-width: 0px, 0px, 1px, 2px;
  border-style: solid;
  border-color: #F2F4F8;
  border: 1px solid #F2F4F8;
  

  &:hover {
    color: ${({ sidebarActive }) => sidebarActive ? "#FFFFFF" : "#000000"};
  }
`;

const SidebarLabel = styled.span`
  margin-left: 14px;
  font-family: "Roboto";
  font-size: 15px;
  font-weight: 400;
  line-height: 16.42px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  /* color: #21272A; */
`;

const DropdownLink = styled(Link)`
  display: flex;
  gap: 0px;
  margin-left: 1rem;
  justify-content: space-between;
  align-items: center;
  padding: 18px 18px 18px 18px;
  height: 45px;
  text-decoration: none;
  /* margin-bottom: 1px; */
  color: ${({ sidebarActive }) => sidebarActive ? "#FFFFFF" : "#FFFFFF"};
  background: ${({ sidebarActive }) => sidebarActive ? "rgba(59, 108, 243, 0.53)" : " "};
  border-left: ${({ sidebarActive }) => sidebarActive ? "3px solid #FFFFFF" : " "};
  border-right: ${({ sidebarActive }) => sidebarActive ? "3px solid #FFFFFF" : " "};
  &:hover {
    color: rgb(12, 45, 6);
  }
`;

const IconLabel = styled.div`
  width: 100%;
  border-radius: 1.5px;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;

  }
`;

const SidebarIcon = styled.span`
  font-size: 1.2rem;

  &:hover {
    color: #21afe6;
  }
`;

const SubMenu = ({ userData, item, isOpen, onToggle }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const sidePathname = location.pathname.split("")[1];

  // Define isActive logic for related paths
  const isActive =
    location.pathname === item.path ||
    (item.path.includes("/userManagement") && (location.pathname.includes("/userManagement") || location.pathname.includes("/userDetails") || location.pathname.includes("/registrationDetails") || location.pathname.includes("/registrationRequest") || location.pathname.includes("/certificateRequest"))) ||
    (item.path.includes("/registrationRequest") && location.pathname.includes("/registrationDetails"))||
    (item.path.includes("/gigsManagement") && location.pathname.includes("/gigOverview"))||
    (item.path.includes("/reportedGigManagement") && location.pathname.includes("/reportUserList"))||
    (item.path.includes("/cmsManagement") && (location.pathname.includes("/cmsManagement") || location.pathname.includes("/fAQs") || location.pathname.includes("/addUpdateFAQs") || location.pathname.includes("/contactUs") || location.pathname.includes("/aboutUs") || location.pathname.includes("/terms&Conditions") )) ||
    // (item.path.includes("/fAQs") && location.pathname.includes("/addUpdateFAQs")) ||
    (item.path.includes("/notificationManagement") && location.pathname.includes("/createNotification"))||
    (item.path.includes("/reportedGigManagement") && location.pathname.includes("/reportUserList"))||
    (item.path.includes("/ticketManagement") && location.pathname.includes("/ticketManagementHistory"))||


    (item.path.includes("/blockManagement") && location.pathname.includes("/addUpdateBlockManagement")) || (item.path.includes("/blockManagement") && location.pathname.includes("/blockManagementDetails")) ||
    // (item.path.includes("/serviceProviderStatus") && (location.pathname.includes("/serviceProviderStatus") || location.pathname.includes("/serviceProviderDetails") || location.pathname.includes("/verificationRequestDetails") || location.pathname.includes("/verificationRequests"))) ||
    //(item.path.includes("/termsAndCondition") && (location.pathname.includes("/termsAndCondition") || location.pathname.includes("/faqManagement") || location.pathname.includes("/addUpdateFAQs") || location.pathname.includes("/cancellstionPolicy") || location.pathname.includes("/aboutUs") || location.pathname.includes("/privacyPolicy"))) ||
   
    (item.path.includes("/subAdminManagement") && location.pathname.includes("/subAdminDetail")) ||
   
    (item.path.includes("/changedPassword") && location.pathname.includes("/changedPassword"));
    (item.path.includes("/profile") && location.pathname.includes("/profile"));



  return (
    <>
      <SidebarLink
        sidebarActive={isActive}
        to={item.path}
        // onClick={item.subNav ? onToggle : null}
        // as={item.subNav ? "div" : "a"} // Disable navigation for dropdown
        onClick={item.subNav ? onToggle : () => navigate(item.path)} // Only toggle if dropdown
      >
        <IconLabel sidebarActive={isActive}>
          <SidebarIcon style={{ color: isActive ? "rgba(255, 255, 255, 1)" : "#21272A" }}>
            {isActive && item.activeIcon ? item.activeIcon : item.icon}
          </SidebarIcon>
          <SidebarLabel style={{ color: isActive ? "rgba(255, 255, 255, 1)" : "#21272A" }}>
            {item.title}
          </SidebarLabel>
        </IconLabel>
        <div  >
          {item.subNav && isOpen
            ? item.iconOpened
            : item.subNav
              ? item.iconClosed
              : null}
        </div>
      </SidebarLink>
      {isOpen &&
        item.subNav?.map((subItem, index) => (
          <DropdownLink
            to={subItem.path}
            // sidebarActive={(location.pathname == subItem.path || sidePathname == subItem.path.split("/")[1])}
            sidebarActive={location.pathname.includes(subItem.path) || (subItem.path.includes("/userManagement") && location.pathname.includes("/userDetails")) ||
              (subItem.path.includes("/registrationRequest") && location.pathname.includes("/registrationDetails")) || (subItem.path.includes("/faqManagement") && location.pathname.includes("/addUpdateFAQs"))}
            key={index}
          >
            <IconLabel >
              <SidebarIcon style={{ color: location.pathname === subItem.path  ? "rgba(255, 255, 255, 1)" : "#21272A" }}>
                {isActive && subItem.activeIcon ? subItem.activeIcon : subItem.icon}
              </SidebarIcon>
              <SidebarLabel style={{ color: location.pathname == subItem.path ? "rgba(255, 255, 255, 1)" : "#21272A" }}>
                {subItem.title}
              </SidebarLabel>
            </IconLabel>
          </DropdownLink>
        ))}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubMenu);